export function computeWidthFromRef(vueInstance, ref) {
  const element = vueInstance.$refs[ref];
  // TODO: Consider if we need to reference $el
  return element.getBoundingClientRect().width;
}

export function computeWidthFromFirstClassInstance(className) {
  const trendingEntries = document.getElementsByClassName(className);
  if (trendingEntries.length < 1) {
    return undefined;
  }
  return trendingEntries[0].getBoundingClientRect().width;
}
